interface IKeepitalSubscriptionPackageConstant {
  TYPE: {
    FREE: string;
    MID: string;
    LITE: string;
  };
}

const KEEPITAL_SUBSCRIPTION_PACKAGE: IKeepitalSubscriptionPackageConstant = {
  TYPE: {
    FREE: 'free',
    MID: 'mid',
    LITE: 'lite',
  },
};

export default KEEPITAL_SUBSCRIPTION_PACKAGE;
